import { ThumbsUp } from 'lucide-react';
import { Icon } from '../../helpers/Icons/Icon';

const WhyCreditBuilder = () => (
  <div className='flex flex-col items-start  gap-5 w-full max-w-[1200px]'>
    <div className='flex flex-col items-start gap-7 w-full'>
      <span className='text-medium font-[400] text-[20px] tracking-[0.4px]'>
        Why Credit Builder?
      </span>
      <div className='flex flex-col mds:flex-row gap-12'>
        <div className='relative w-full flex items-center'>
          <div className='absolute bottom-1 left-1/2 translate-x-[-50%] w-[80%] h-[60px] rounded-[20px] shadow-[0px_12px_50px_0px_#A6B1CB] z-0 pointer-events-none max-w-[400px]'></div>
          <div className='relative z-5 min-w-[200px] min-h-[160px]  border border-[#EFF2FB] rounded-[20px] bg-[linear-gradient(180deg,#F3F4F9_0%,#DEE3F5_100%)] px-[20px] py-[20px]'>
            <div className='flex flex-col items-start gap-3'>
              <Icon name='rocket' className='text-primary' strokeWidth={0.1} />
              <span className='text-[#757D94] font-normal text-[14px] leading-[18px] tracking-[0.14px] '>
                Build or boost your credit score with on-time rent payments
              </span>
            </div>
          </div>
        </div>
        <div className='relative w-full flex items-center'>
          <div className='absolute bottom-1 left-1/2 translate-x-[-50%] w-[80%] h-[60px] rounded-[20px] shadow-[0px_12px_50px_0px_#A6B1CB] z-0 pointer-events-none'></div>
          <div className='relative z-5 min-w-[200px] min-h-[160px]  border border-[#EFF2FB] rounded-[20px] bg-[linear-gradient(180deg,#F3F4F9_0%,#DEE3F5_100%)] px-[20px] py-[20px]'>
            <div className='flex flex-col items-start gap-3'>
              <ThumbsUp className='text-primary h-7 w-7' />
              <span className='text-[#757D94] font-normal text-[14px] leading-[18px] tracking-[0.14px] '>
                Show lenders you manage housing costs responsibly
              </span>
            </div>
          </div>
        </div>
        <div className='relative w-full flex items-center'>
          <div className='absolute bottom-1 left-1/2 translate-x-[-50%] w-[80%] h-[60px] rounded-[20px] shadow-[0px_12px_50px_0px_#A6B1CB] z-0 pointer-events-none'></div>
          <div className='relative z-5 min-w-[200px] min-h-[160px]  border border-[#EFF2FB] rounded-[20px] bg-[linear-gradient(180deg,#F3F4F9_0%,#DEE3F5_100%)] px-[20px] py-[20px]'>
            <div className='flex flex-col items-start gap-3'>
              <Icon name='curlyCheck' className='text-primary' strokeWidth={0.1} />
              <span className='text-[#757D94] font-normal text-[14px] leading-[18px] tracking-[0.14px] '>
                Establish a verified payment history for future mortgage applications
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default WhyCreditBuilder;
